import React from 'react';
import styled from 'styled-components';

import { useScreenQuery } from 'playup-web-core';

import GlobalContext from '../../../contexts/GlobalContext';

const ApprovedOperators = () => {
	const { isSmall } = useScreenQuery();
	const { linkGroups } = React.useContext(GlobalContext);
	const { operators } = React.useMemo(
		() => ({
			operators: linkGroups.find((linkGroup) => linkGroup.type.id === 1),
		}),
		[linkGroups]
	);

	if (!operators || !operators.links || operators.links.length < 1) return null;

	return (
		<SectionContainer>
			<Title isSmallScreen={isSmall}>{operators.name}</Title>
			<OperatorImageGroup>
				{operators.links.map((operator) => (
					<OperatorImage
						key={operator.name}
						isSmallScreen={isSmall}
						src={isSmall ? operator.images.mobile : operator.images.desktop}
						alt={operator.name}
						isWhiteColor={operator.name === 'PGA'}
					/>
				))}
			</OperatorImageGroup>
		</SectionContainer>
	);
};

export default ApprovedOperators;

const SectionContainer = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	marginTop: '20px',
	borderTopColor: theme.colors.lightGreyR,
}));

const Title = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	textTransform: 'uppercase',
	fontSize: isSmallScreen ? '14px' : '18px',
	margin: '20px 0',
	color: theme.colors.white,
	fontWeight: 600,
}));

const OperatorImageGroup = styled.div({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'center',
});

const OperatorImage = styled.img<{ isSmallScreen: boolean; isWhiteColor?: boolean }>(
	({ isSmallScreen, isWhiteColor }) => ({
		height: isSmallScreen ? '36px' : '48px',
		margin: '0 5px',
		filter: isWhiteColor ? 'invert(100%)' : 'none',
	})
);
